const COMMON_COLORS = {
  menuItemSelected: 'rgba(12, 147, 143, 0.08)',
  menuItemSelectedHover: 'rgba(12, 147, 143, 0.1)',
  menuItemHover: 'rgba(0, 0, 0, 0.04)',
};

export const sxStyles = {
  listItemButton: {
    margin: '0 8px',
    minHeight: 48,
    '&.Mui-selected': {
      backgroundColor: `${COMMON_COLORS.menuItemSelected}`,
      '&:hover': { backgroundColor: `${COMMON_COLORS.menuItemSelectedHover}` },
      borderTop: `1px solid rgba(0, 0, 0, 0.0)`,
    },
    '&:hover': { backgroundColor: `${COMMON_COLORS.menuItemHover}` },
    height: '56px',
  },
  listItemIcon: {
    color: 'inherit',
    justifyContent: 'center',
    minWidth: 0,
    mr: 2,
  },
};
